// ============================================================================
// sttTranscript — накопление распознанной речи (SSoT/SRP, без React).
//
// Правила консультации §1/§3:
//   • interim ЗАМЕНЯЕТСЯ целиком (не склеивается с предыдущим);
//   • финальные порции накапливаются;
//   • финальный текст отдаётся В ПОЛЕ/СООБЩЕНИЕ РОВНО ОДИН РАЗ (commit);
//   • повторный commit возвращает пустую строку (STT не перезаписывает).
// ============================================================================

export interface TranscriptSnapshot {
  /** Накопленный финальный текст. */
  final: string;
  /** Текущая промежуточная порция (заменяется целиком). */
  interim: string;
  /** Что показывать в live-подписи: финал + промежуточное. */
  display: string;
}

export interface TranscriptBuffer {
  /** Промежуточная порция: полностью заменяет предыдущую. */
  setInterim(text: string): void;
  /** Финальная порция: добавляется к накопленному. */
  addFinal(text: string): void;
  snapshot(): TranscriptSnapshot;
  /** Отдать итоговый текст ОДИН раз (сброс буфера). */
  commit(): string;
  reset(): void;
  /** Был ли commit (защита от повторной вставки). */
  readonly committed: boolean;
}

/** Склейка фрагментов речи без двойных пробелов. */
export function joinTranscript(a: string, b: string): string {
  const left = (a || '').trim();
  const right = (b || '').trim();
  if (!left) return right;
  if (!right) return left;
  return `${left} ${right}`;
}

export function createTranscriptBuffer(): TranscriptBuffer {
  let final = '';
  let interim = '';
  let committed = false;

  return {
    setInterim(text: string) {
      interim = (text || '').trim();
    },
    addFinal(text: string) {
      const chunk = (text || '').trim();
      if (!chunk) return;
      final = joinTranscript(final, chunk);
      interim = '';
    },
    snapshot() {
      return { final, interim, display: joinTranscript(final, interim) };
    },
    commit() {
      if (committed) return '';
      committed = true;
      const out = joinTranscript(final, interim);
      final = '';
      interim = '';
      return out;
    },
    reset() {
      final = '';
      interim = '';
      committed = false;
    },
    get committed() {
      return committed;
    },
  };
}
